module.exports = typeof window == 'object' && typeof Deno != 'object';



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/internals/engine-is-browser.js
// module id = 376
// module chunks = 2